import { EntityApi, ProductInfoComponent, ProductType, ShoppingBagComponent } from '@inter-ikea-storageone/range';
import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
export class BestaEntityApi extends EntityApi {
    /**
     * @override
     * @returns productId and entityId for all shoppingbag entities in the scene
     */
    getAllShoppingBagEntities() {
        const frames = this.getByComponent(ComponentIds.FRAME_COMPONENT_ID);
        const sharedLegs = frames.flatMap(frame => HierarchyUtils.filterInHierarchy(frame, e => {
            const partKey = e.getComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID)
                ?.partKey;
            const isSharedLeg = partKey === 'leg-shared-1' || partKey === 'leg-shared-2';
            return e.hasComponent(ComponentIds.LEG_COMPONENT_ID) && isSharedLeg;
        }));
        let usedleg;
        let legsAdded = 0;
        let shoppingBagEntities = this.getByComponent(ShoppingBagComponent.id).map((entity) => {
            const productEntity = {
                entityId: entity.id,
                productId: entity.getComponent(ShoppingBagComponent.id).productId
            };
            if (entity.hasComponent(ComponentIds.LEG_COMPONENT_ID) &&
                entity.getComponent(ProductInfoComponent.id)?.productType !==
                    ProductType.BESTA_SUPPORTING_LEG) {
                legsAdded = legsAdded + 1;
                usedleg = productEntity;
            }
            return productEntity;
        });
        const legPackages = Math.ceil(legsAdded / 2);
        if (sharedLegs.length > legPackages) {
            const extraLegs = Array.from(Array(sharedLegs.length - legPackages)).flatMap(() => usedleg ? [usedleg, usedleg] : []);
            shoppingBagEntities = [...shoppingBagEntities, ...extraLegs];
        }
        return shoppingBagEntities;
    }
}
//# sourceMappingURL=BestaEntityApi.js.map